module.exports = __webpack_public_path__ + "img/x4.18b48fdc.png";